<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ProtocolHandlerRow from '@/components/ProtocolHandlerRow.vue'
import { isSupported } from '@/protocols/register'

const { t } = useI18n()
</script>

<template>
  <section class="card">
    <h3>{{ t('settings.protocols.title') }}</h3>
    <p class="hint">{{ t('settings.protocols.intro') }}</p>
    <p v-if="!isSupported()" class="hint" role="status">
      {{ t('settings.protocols.unsupported') }}
    </p>
    <div class="handlers">
      <ProtocolHandlerRow
        scheme="web+todo"
        :title="t('settings.protocols.webTodo.title')"
        :description="t('settings.protocols.webTodo.description')"
        example="web+todo:calendar/7/tag/Home?status=done"
      />
      <ProtocolHandlerRow
        scheme="geo"
        :title="t('settings.protocols.geo.title')"
        :description="t('settings.protocols.geo.description')"
        example="geo:52.520008,13.404954"
      />
    </div>
  </section>
</template>

<style scoped>
.card {
  background: var(--tg-section-bg-color);
  border-radius: 0.75rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.hint {
  font-size: 0.85rem;
  color: var(--tg-hint-color);
}

.handlers {
  display: grid;
  gap: 1rem;
}
</style>
